export const NOISE_OPTIONS = [
  { value: "jamais", label: "Jamais" },
  { value: "vers_la_fin", label: "Vers la fin" },
  { value: "souvent", label: "Souvent" },
];
export const TALK_OPTIONS = [
  { value: "oui_facilement", label: "Oui, facilement" },
  { value: "phrases_courtes", label: "Phrases courtes" },
  { value: "non", label: "Non" },
];
export const PAIN_OPTIONS = [
  { value: "non", label: "Non" },
  { value: "genee_partie", label: "Une gêne, partie" },
  { value: "douleur_restee", label: "Une douleur restée" },
];
export const ALERT_OPTIONS = [
  { value: "courbatures_un_cote", label: "Courbatures d'un seul côté" },
  { value: "raideur_72h", label: "Raideur qui dure plus de 72 h" },
  { value: "douleur_echauffement", label: "Douleur dès l'échauffement" },
];
export const EFFORT_LABELS = { 1: "Très facile", 2: "Facile", 3: "Plutôt facile", 4: "Moyen", 5: "Soutenu", 6: "Très difficile", 7: "Échec, pas terminée" };

export const PAIN_ZONES = [
  { value: "pied", label: "Pied" },
  { value: "achille", label: "Tendon d'Achille" },
  { value: "tibia", label: "Tibia" },
  { value: "genou", label: "Genou" },
  { value: "hanche", label: "Hanche" },
  { value: "dos", label: "Dos" },
];

export const PLAN_LABEL = {
  essai: { title: "Essai gratuit — 1 mois", price: "0 €", sub: "Non renouvelable. Pour découvrir la méthode et poser ton KM01." },
  "3m": { title: "Programme 10K — 3 mois", price: "14,90 €", sub: "Objectif : courir 5 km ou 10 km. Paiement unique." },
  "6m": { title: "Programme 21/42K — 6 mois", price: "24,90 €", sub: "Objectif : ton premier semi ou ton premier marathon. Paiement unique." },
};

export const WEEK_KIND = { decouverte: "Découverte", consolidation: "Consolidation", plus_longue: "Plus longue", allegee: "Allégée" };
export const WEEK_KIND_ECHELLE = { encaisse: "On encaisse", charge: "Charge", allegee: "Allégée + sortie longue" };

export const MILESTONE_TEXT = {
  KM01: { title: "Ton KM01.", text: "Tout le monde a un KM01. Le 0, c'était toi avant. Le 1, c'est ton premier kilomètre. Entre les deux, il n'y avait qu'un pas : tu l'as fait." },
  KM03: { title: "KM03 passé.", text: "Trois semaines sans forcer, en écoutant ton corps. La semaine prochaine est allégée : profite." },
  KM05: { title: "KM05 passé.", text: "Tu cours 20 à 30 minutes sans t'arrêter. C'est exactement ce que tu étais venu chercher." },
  KM10: { title: "KM10 passé.", text: "Ton premier palier de 12 km, en blocs de 3 km. La course fait partie de ta vie. À toi de choisir : progresser en distance ou travailler ta vitesse." },
  KM21: { title: "KM21 passé.", text: "4 × 5 km, 21 km au total : la distance d'un semi. Le premier kilomètre menait ici. Même méthode, même écoute : l'échelle continue, à ton rythme." },
  KM15: { title: "KM15 passé.", text: "Une sortie longue de 15 km, en blocs, avec la marche qui garde le cœur calme. Le semi n'est plus une idée : c'est la prochaine marche de l'échelle." },
  KM25: { title: "KM25 passé.", text: "25 km en une sortie. Au-delà du semi, ton corps apprend à durer : manger, boire, marcher sans culpabilité. Le marathon se construit ici." },
  KM30: { title: "KM30 passé.", text: "30 km. La plus longue sortie avant le jour J. Tout ce qui reste, c'est de la fraîcheur à garder : les prochaines semaines s'allègent." },
  KM42: { title: "KM42 passé.", text: "Un marathon. Tout a commencé par un KM01. Tu n'as plus rien à prouver : continue à courir pour le plaisir, sans montre." },
};

export const STAGE_INTRO = {
  echelle: { title: "Tu entres dans l'échelle des paliers.", text: "Ton corps a besoin de 3 semaines pour s'adapter à une sortie inhabituelle : l'os et l'articulation sont plus lents que le muscle. Alors on avance bloc par bloc — une semaine pour encaisser, une de charge, une allégée — et une sortie longue un peu plus longue tous les 21 jours : 3 × 2 km, puis 3 × 3, 4 × 3… jusqu'au KM21 et, si tu veux, au KM42. Marcher entre les blocs n'est pas un échec : c'est la méthode. On change d'allure pour réveiller les grands muscles, jamais pour forcer." },
};

export function parseDuration(text) {
  const t = (text || "").trim().replace(",", ".");
  if (!t) return null;
  if (t.includes(":")) {
    const parts = t.split(":").map((x) => parseInt(x, 10));
    if (parts.some((x) => Number.isNaN(x))) return null;
    if (parts.length === 3) return Math.round((parts[0] * 60 + parts[1] + parts[2] / 60) * 10) / 10;
    if (parts.length === 2) return Math.round((parts[0] + parts[1] / 60) * 10) / 10;
    return null;
  }
  const n = parseFloat(t);
  return Number.isNaN(n) ? null : n;
}
